module.exports = __webpack_public_path__ + "static/media/bigcheck.1321ee36.svg";